export default __webpack_public_path__ + "img/jo-d10403cf2a3186b657b4cb451939e9f8.png";